import { c as _c } from "react/compiler-runtime";
import { memo, type ReactNode } from 'react';
interface VaultV2SummaryRowProps {
  label: string;
  labelSlot?: ReactNode;
  children: ReactNode;
}
const VaultV2SummaryRow = t0 => {
  const $ = _c(8);
  const {
    label,
    labelSlot,
    children
  } = t0;
  let t1;
  if ($[0] !== label) {
    t1 = <span className="text-3xs text-secondary-foreground">{label}</span>;
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== labelSlot || $[3] !== t1) {
    t2 = <div className="gap-2xs flex flex-row items-center">{t1}{labelSlot}</div>;
    $[2] = labelSlot;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== children || $[6] !== t2) {
    t3 = <div className="flex min-h-[20px] flex-row items-center justify-between">{t2}{children}</div>;
    $[5] = children;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export default memo(VaultV2SummaryRow);